import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification,InputNumber } from 'antd';
import {getStoresList, postTag, uploadLogo} from '../../modules/Api';
import history from '../../modules/History';
import Editor from 'for-editor';
import {END_POINT} from "../../constants/config";
const EditorToolbar = {
  h1: false, 
  h2: true, 
  h3: true, 
  h4: true, 
  h5: true, 
  img: false, 
  link: true, 
  code: false, 
  preview: true, 
  expand: true, 
  /* v0.0.9 */
  undo: true, 
  redo: true, 
  save: false, 
  /* v0.2.3 */
  subfield: true,
}

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CouponForm extends React.Component {
    constructor() {
        super();
        this.state = {
            types: [],
            currencies: [],
            brands: [],
            filteredStoreKeyword: '',
            is_limited: false,
            is_pre_publish: false,
            is_scoreable: 0,
            is_lucky: false,
            notif: false,
            loading: false,
            selectedTags: [],
            tags: [],
            tmp: false,
            storeLogo:null,
            code_file: null,
            is_unique: false,
            data: {}
        }
    }

    componentDidMount() {
        getStoresList(``, res => {this.setState({brands: res})});
        this.setState({
            tmp:this.props.initialData.is_limited,
            is_unique: this.props.initialData.is_unique,
            is_lucky: this.props.initialData.is_lucky,
            is_pre_publish: this.props.initialData.is_pre_publish,
            is_scoreable: this.props.initialData.score > 0,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.image && this.state.storeLogo === null) {
            this.setState({storeLogo: nextProps.initialData.image});
        }

        this.setState({data: nextProps.initialData});

        if (this.state.selectedTags.length === 0 && nextProps.initialData.tag && nextProps.initialData.tag.length > 0) {
            this.setState({selectedTags: nextProps.initialData.tag});
        }
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            if(!this.state.is_scoreable){
                fieldsValue['score'] = null;
            }
            this.props.submit(Object.assign({},
                {
                    image: this.state.storeLogo,
                },
                fieldsValue, {
                    tag: this.state.selectedTags.map(t => t.key)
                }
            ));
        })
    }

    get isUnique() {
        // dont use ===
        return this.props.form.getFieldValue('is_unique') == 1;
    }

    commitTags(items) {
        this.setState({tags: [], selectedTags: items});
        items.forEach(t => {
            postTag({title: t.label}, id => {
                this.setState({selectedTags: this.state.selectedTags.map(d => {
                    return d.label === t.label ? Object.assign({}, d, {key: id}) : d;
                })});
            });
        });
    }

    brandFilterOption = (input, option) => option.key.includes(input);

    render() {
        const brands = this.state.brands.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));

        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>

                    </Col>

                    <Col span={11} offset={1}>

                        <FormItem
                            {...formItemLayout}
                            label={"عنوان"}
                            colon={false}>
                            {getFieldDecorator('title', {
                                initialValue: this.props.initialData.title,
                                rules: [{
                                required: true, message: 'عنوان فرصت شغلی را وارد نمایید!',
                                }],
                            })(
                                <Input placeholder="استخدام ..." />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label={"زمان همکاری"}
                            colon={false}>
                            {getFieldDecorator('time', {
                                initialValue: this.props.initialData.time,
                                rules: [{
                                    required: true, message: 'تایم همکاری را وارد نمایید!',
                                }],
                            })(
                                <Input placeholder="تمام وقت" />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label={"موقعیت شغلی"}
                            colon={false}>
                            {getFieldDecorator('position', {
                                initialValue: this.props.initialData.position,
                                rules: [{
                                    required: true, message: ' موقعیت شغلی را وارد نمایید!',
                                }],
                            })(
                                <Input placeholder="برنامه نویس | گرافیست و..."/>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label={"توضیحات"}
                            colon={false}>
                            {getFieldDecorator('description', {
                                initialValue: this.props.initialData.description,
                                rules: [{
                                required: true, message: 'توضیحات فرصت شغلی را وارد نمایید!',
                                }],
                            })(
                                <Editor placeholder="توضیحات" toolbar={EditorToolbar}/>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="تصویر"
                              // extra="بهتر است فایل انتخابی مربعی و حداقل عرض ۳۰۰ پیکسل و فرمت jpg باشد."
                            colon={false}>
                            {getFieldDecorator('logo', {
                                valuePropName: 'fileList',
                                getValueFromEvent: this.normFile,
                            })(
                                <Upload
                                    name="logo"
                                    action=""
                                    customRequest={() => {}}
                                    onChange={f => {uploadLogo(f, (src) => {this.setState({storeLogo: src})})}}
                                    listType="picture"
                                    showUploadList={false}>
                                    <Button>
                                        <Icon type="upload" /> انتخاب فایل
                                    </Button>
                                    <br />
                                    {this.state.storeLogo && <img src={`${this.state.storeLogo.includes('http') ? this.state.storeLogo : END_POINT + this.state.storeLogo}`} style={{width: '50px', height: '50px', margin: '10px'}} alt="لوگو فروشگاه"/>}
                                </Upload>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="فرصت شغلی فعال است ؟"
                            colon={false}>
                            {getFieldDecorator('status', {
                                valuePropName: 'checked',
                                initialValue: this.props.initialData.status ? true : false
                            })(
                                <Switch checkedChildren="بله" unCheckedChildren="خیر"/>
                            )}
                        </FormItem>

                    </Col>


            </Row>

                <FormItem>
                    <div className="btn-container">
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                        >
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </div>
                </FormItem>
            </Form>
        </div>
        )
    }
}
CouponForm.defaultValue = {
    initialData: {}
}

export default Form.create({ name: 'horizontal_login' })(CouponForm);



// WEBPACK FOOTER //
// ./src/containers/Jobs/form.js